<template>
    <div style="height: 100%; overflow: auto">
        <b-card class="sa-card sa-card-border" header="Dettagli Stanza" header-tag="header" footer-tag="footer" title="">
            <!-- <template #header>
                <div style="display: flex">
                    <span style="flex: 1">Dettagli Stanza</span>
                    <b-button size="sm" variant="outline-secondary outline-secondary-noborder pull-right" @click="onClickPianoEdit()">
                        <i class="bi bi-pencil"></i>
                    </b-button>
                </div>
            </template> -->
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Struttura</label>
                    <span class="sa-data">{{ jsonData.denominazioneStruttura }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Presidio</label>
                    <span class="sa-data">{{ jsonData.denominazionePresidio }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Piano</label>
                    <span class="sa-data">{{ jsonData.nomePiano }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <label class="sa-label-data">Codice Reparto</label>
                    <span class="sa-data">{{ jsonData.codiceReparto }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <label class="sa-label-data">Descrizione Reparto</label>
                    <span class="sa-data">{{ jsonData.descrizioneReparto }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <label class="sa-label-data">Nome</label>
                    <span class="sa-data">{{ jsonData.nome }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                    <label class="sa-label-data">Sesso</label>
                    <span class="sa-data">{{ jsonData.descrizioneSesso }}</span>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">Note</label>
                    <span class="sa-data">{{ jsonData.note }}</span>
                </b-col>
            </b-row>
        </b-card>
        <!--  <div class="sa-list-component">
            <rsa-configurazione-posti-letto-letti-list-component ref="cmpRsaConfigurazionePostiLettoLettoList" @clickNuovoLetto="onClickNuovoLetto" />

            
        </div> -->
        <rsa-configurazione-posti-letto-letti-edit-component ref="cmpRsaConfigurazionePostiLettoLettiEdit" @saveResponse="onSaveResponse" />
    </div>
</template>

<!-- 
        
    -->

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import RsaConfigurazionePostiLettoLettiEditComponent from "./RsaConfigurazionePostiLettoLettiEditComponent.vue";
export default {
    mixins: [UtilityMixin],
    components: { RsaConfigurazionePostiLettoLettiEditComponent },
    data() {
        return {
            id: null,
            strutturaOptions: [],
            pathResource: "/rsapostilettostanze",
            pathResourceStrutture: "/strutture",
            listKey: 0,
            jsonData: {},
            currentPage: 1,
            listaLetti: [],
            keyPiano: 100,
            perPage: 50,
            rows: 0,
            //   titoloModale: "Nuovo Letto",
        };
    },
    watch: {
        jsonData: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    mounted() {
        let me = this;
        me.id = this.$route.params.id;
    },
    methods: {
        loadDataStruttureSuccess(response) {
            let me = this;
            me.strutturaOptions = response.data.data;
            me.strutturaOptions.unshift({ codiceStruttura: null, denominazione: this.$i18n.t("clinic.lblSelectStructure") });
            me.loadData();
            me.$emit("afterLoadData");
        },
        loadDataStruttureError(response) {
            let me = this;
            me.$bvToast.toast("Errore durante il caricamento delle strutture", response, {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
            me.$emit("afterLoadData");
        },
        loadData(id) {
            let me = this;
            me.loadDataResources(me.pathResource + "/" + id, null, me.loadDataSuccess, me.loadDataError);
            me.$emit("beforeLoadData");
            // console.log("loadData: ", id);
        },
        loadDataSuccess(response) {
            let me = this;
            me.$emit("afterLoadData");
            me.jsonData = response.data.data;
            me.$emit("setLinkBack", me.jsonData.idPiano);
            me.keyPiano++;
        },
        loadDataError(response) {
            let me = this;
            me.$bvToast.toast("Errore durante il caricamento dei dati", response, {
                title: "Errore",
                variant: "success",
                solid: true,
            });
            me.$emit("afterLoadData");
        },

        saveSucessResponse() {
            let me = this;
            me.loadData();
        },
        saveErrorResponse(response) {
            if (response.response.status === 400) {
                this.$emit("errorRestCall", response);
            } else {
                this.$bvToast.toast("Errore nel salvarei dati del Piano: " + response.message, {
                    title: "",
                    variant: "danger",
                    solid: true,
                });
            }
        },
        onClickNuovoLetto(id) {
            let me = this;
            me.jsonData.id = id;
            me.$refs.cmpRsaConfigurazionePostiLettoLettiEdit.show(id);
            // console.log("jsonData", me.jsonData);
            // console.log("id jsondata", me.jsonData.id);
        },
        // onShowModal() {
        //     let me = this;
        //     setTimeout(() => {
        //         if (me.$refs.cmpRsaConfigurazionePostiLettoLettiEdit) {
        //             me.$refs.cmpRsaConfigurazionePostiLettoLettiEdit.init(me.id);
        //         } else {
        //             console.log("NO");
        //         }
        //     }, 1000);
        // },
        // onOkConfigurazioneLetti() {
        //     let me = this;
        //     me.$refs.cmpRsaConfigurazionePostiLettoLettiEdit.salvaLetto();
        // },
        // onHidden() {
        //     console.log("Modal chiusa");
        // },
        onSaveResponse() {
            let me = this;
            me.loadData();
        },
    },
};
</script>

<style></style>
